import ReactECharts from "echarts-for-react";

const RainIndicator = ({ value = 0 }: { value: number }) => {

    const bodyMax = 100;

    const labelSetting: echarts.PictorialBarSeriesOption['label'] = {
        show: true,
        position: 'top',
        offset: [0, 50],
        formatter: function (param: any) {
            return ((param.value / bodyMax) * 100).toFixed(0) + 'mm';
        },   
        fontSize: 18,
        fontWeight: "bold",
        fontFamily: 'Arial'
    };


    const option = {
        xAxis: {
            data: ['Precipitation', 'Precipitation', 'Precipitation', 'Precipitation', 'Precipitation'],
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false }
        },
        yAxis: {
            max: bodyMax,
            show: false,
            splitLine: { show: false }
        },
        grid: {
            height: 99,
            top: 'center',
            left: 'center',
            right: 'center',
            bottom: 'center',
            containLabel: false,
        },
        markLine: {
            z: -100
        },
        series: [
            {
                name: 'typeA',
                type: 'pictorialBar',
                symbolClip: true,
                symbolBoundingData: bodyMax,
                label: labelSetting,
                data: [
                    {
                        value: value,
                        symbol: 'circle',
                        symbolSize: [100, 100]
                    },
                ],
                z: 10
            },
            {
                name: 'full',
                type: 'pictorialBar',
                symbolBoundingData: bodyMax,
                animationDuration: 0,
                label: !value ? labelSetting : "",
                itemStyle: {
                    color: '#ccc'
                },
                data: [
                    {
                        value: 0,
                        symbol: 'circle',
                        symbolSize: [100, 100]
                    }
                ]
            }
        ]
    };

    return <ReactECharts option={option} style={{ height: 100, width: 270 }} />
};

export { RainIndicator };